import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { JwtUtils } from '../utils/jwt.utils';
import { SignIn } from '../../services/auth-api/models/user-sign-in.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  /**
   *
   */
  constructor() {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.

    let url = req.url.toString();
    if (
      url.startsWith(environment.authApi) ||
      url.startsWith(environment.waiApi)
    ) {
      environment;
      let singInReponse: SignIn | undefined = localStorage.getItem(
        'singInReponse'
      )
        ? JSON.parse(localStorage.getItem('singInReponse') ?? '')
        : undefined;

      if (singInReponse) {
        if (!JwtUtils.isTokenExpired(singInReponse.accessToken)) {
          newReq = req.clone({
            headers: req.headers.set(
              'Authorization',
              `Bearer ${singInReponse.accessToken}`
            ),
          });
        }
      }
    }

    // Response
    return next.handle(newReq).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }
}
